export default __webpack_public_path__ + "static/media/carbs.5fdcfe1b.png";